<div class="step-four">
    <h2>Compra Cancelada!</h2>

    <p>No hemos podido procesar el pago, si tuviste algún inconveniente, por favor ponete en contacto con nosotros vía whatsapp (3462) 583388 o al mail plazahogar@amvt.com.ar</p>

    <div class="buttons">
        <button mat-button [routerLink]="['/']">Volver al inicio</button>
        <button mat-button [routerLink]="['/carrito-de-compras']">Ir al carrito</button>
    </div>
</div>